<template>
  <div class="person-block">
    <div class="member-block">
      <div class="member-block-item">
        <h4>Middle Name:</h4>
        <p>{{ person.middle }}</p>
      </div>
      <div class="member-block-item">
        <h4>Date of birth:</h4>
        <p>{{ person.dob }}</p>
      </div>

      <div v-show="!edit">
        <div v-if="!isChild" class="member-block-item">
          <h4>Primary contact number:</h4>
          <p>{{ person.tel1 }}</p>
        </div>

        <div v-if="!isChild" class="member-block-item">
          <h4>Alternative Contact No:</h4>
          <p :class="pleaseAdviseStyle">{{ pleaseAdviseText }}</p>
        </div>

        <div v-if="!isChild" class="member-block-item">
          <h4>Email:</h4>
          <p>{{ person.email }}</p>
        </div>
        
        <div class="address-block-btn-container">
          <button
            class="address-block-btn"
            @click="onClickEditToggle"
          >
            <span>Edit</span><i class="material-icons vtd-icon-2 vtd-ml-3"></i>
          </button>
        </div>  
      </div>
    </div>

    <div
      v-show="edit"
      class="member-block-form"
    >
      <b-form
        class="person-form"
        @submit.stop.prevent="onSubmit"
      >
        <b-row>
          <b-col>
            <b-form-group
              label="Primary contact number:"
              class="vtd-form-group"
            >
              <b-form-input
                v-model.trim="$v.form.tel1.$model"
                type="number"
                class="vtd-form-control vtd-form-control-lg "
                :state="validateState('tel1')"
                @keypress="onlyNumbers"
              />
            </b-form-group>  
          </b-col>
        </b-row>
        <b-row>  
          <b-col>
            <b-form-group
              label="Alternative contact number:"
              class="vtd-form-group"
            >
              <b-form-input
                id="input-tel2"
                v-model="form.tel2"
                type="number"
                class="vtd-form-control vtd-form-control-lg "
                @keypress="onlyNumbers"
              />
            </b-form-group>    
          </b-col>
        </b-row>
        <b-row>  
          <b-col>
            <b-form-group
              label="Email:"
              class="vtd-form-group"
            >
              <b-form-input
                id="input-email-profile"
                v-model="form.email"
                type="text"
                class="vtd-form-control vtd-form-control-lg "
              />
            </b-form-group>   
          </b-col>
        </b-row>
        <b-row>
          <div class="address-block-btn-container p-3">
            <button
              class="address-block-btn address-btn-cancel"
              @click.prevent="onClickEditToggle"
            >
              <span>Cancel</span><i class="material-icons vtd-icon-2 vtd-ml-3"></i>
            </button>
            <button
              type="submit"
              class="ml-lg-3 address-block-btn address-btn-submit"
            >
              <span>Submit</span><i class="material-icons vtd-icon-2 vtd-ml-3"></i>
            </button>
          </div>
        </b-row>
      </b-form>  
    </div>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import dayjs from '@/lib/dayjs'
import { mapActions } from 'vuex'
export default {
  props: {
    person: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      edit: false,
      showContent: false,
      form: {
        tel1: this.person.tel1,
        tel2: this.person.tel2,
        email: this.person.email
      }
    }
  },
  validations: {
    form: {
      tel1: {
        required
      },
    }  
  },
  computed: {
    isChild() {
      let age = this.ageFromToday()
      if(age <= 15 || isNaN(age)) {
        return true
      }
      return false
    },
    pleaseAdviseText() {
      let text
      this.person.tel2 === 'N/A' ? text = 'PLEASE ADVISE' : text = this.person.tel2
      return text
    },
    pleaseAdviseStyle() {
      return {
        advise: this.person.tel2 === 'PLEASE ADVISE' || this.person.tel2 === 'N/A' || this.person.email === 'PLEASE ADVISE',
      }
    }
  },
  methods: {
    onClickShowContent() {
      this.showContent = !this.showContent
    },
    onClickEditToggle() {
      this.edit = !this.edit
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
     ...mapActions({
      updatePerson: 'profile/updateProfilePersonAction',
    }),
    async onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }
      await this.updatePerson({person: this.person, values: this.form})
      this.edit = false
    },
    ageFromToday() {
      let age = dayjs(this.person.dob, 'DD-MM-YYYY').format()
      let ageFromNow =  dayjs(age).fromNow()
      let getNum = ageFromNow.slice(0,2)
      return parseInt(getNum)
    },
    onlyNumbers($event){
      // prevents 'e' or any non numerical values, which are still used under type="number", from being entered
      const keyCode = ($event.keyCode ? $event.keyCode : $event.which);
      if(keyCode < 48 || keyCode > 57){ // char codes for numbers
        $event.preventDefault();
      }
    }
  }
}
</script>

<style>
@import "./styles.scss";
.advise {
  color: red;
}
</style>

